// Formats a phone number with its country code, e.g. "+91 9876543210".
export const formatPhone = (
  phone?: string | number | null,
  countryCode?: string | number | null
): string => {
  if (!phone || Number(phone) === 0) return "Not Available";
  const code = String(countryCode ?? "").replace(/[^\d]/g, "");
  return code ? `+${code} ${phone}` : String(phone);
};
